import { createContext } from "react";

export const CommLogPanelContext = createContext();
